import Vue from 'vue'
import RootTableMixin from 'GroomyRoot/mixins/Table.js'

export default Vue.util.mergeOptions(RootTableMixin, {
    data() {
		return {
			isIndexing: false
        }
    }
})